import React, { useContext } from 'react';
import { Spinner } from '../../../StyledComponent';
import { ButtonPrimary } from '../../../StyledComponent';
import { ContextoFinanceiro } from '../../../../services/financeiro';
const MsgCopiarCodBoleto = () => {
  return <span id={'copiarCodigoBoleto'}>CÓDIGO DO BOLETO</span>;
};

export default function BotaoCopiarCodBoleto({
  seuNumero,
  bancoBoleto,
  tema,
  light,
  fullWidth,
  width,
  disabled,
}) {
  const {
    loadingCopiarCodigo,
    codigoCopiado,
    copiaCodigoBoleto,
    erroGetCopiarCodigo,
    boletoCodigoCopiado,
  } = useContext(ContextoFinanceiro);

  const setMensagemCopiarCodigo = () => {
    if (boletoCodigoCopiado === seuNumero && loadingCopiarCodigo) {
      return (
        <>
          <MsgCopiarCodBoleto />
          <Spinner />
        </>
      );
    } else if (boletoCodigoCopiado === seuNumero && codigoCopiado) {
      return <small>Código copiado com sucesso.</small>;
    } else if (boletoCodigoCopiado === seuNumero && erroGetCopiarCodigo) {
      return <small>Ocorreu um erro, tente novamente mais tarde.</small>;
    } else {
      return <MsgCopiarCodBoleto />;
    }
  };
  return (
    <ButtonPrimary
      width={width}
      fullWidth={fullWidth}
      tema={tema}
      light={light}
      onClick={() => copiaCodigoBoleto(bancoBoleto, seuNumero)}
      disabled={erroGetCopiarCodigo || loadingCopiarCodigo || disabled}
    >
      {setMensagemCopiarCodigo()}
    </ButtonPrimary>
  );
}
